

<template>
  <div class="NetPaySuccess">
    <h4 class="text-center cmsg">Estamos procesando su pago...</h4>
  </div>
</template>

<script>
import { servicesAR } from "@/components/services/servicesAR";

export default {
  name: "NetPaySuccess",
  data: () => ({}),
  props: {},
  computed: {
    cart() {}
  },
  methods: {},
  async created() {
    console.log("succesNetPayPage");
    console.log(this.$store.state.route);

    /*  var data = JSON.stringify({
      transactionToken: this.$store.state.route.query.transactionToken,

      tokenRequest: this.$store.state.tokenTemp
    });

    const transactionStats = await servicesAR.transactionStatus(data);
    console.log(transactionStats);*/

    /* if (transactionStats.data.response.responseCode == "00") {
      var dat = {
        id: "okTransaction",
        transactionID: this.$store.state.route.query.transactionToken,
        success: true,
        orderID: transactionStats.data.transaction.orderId
      };
      console.log(dat);
    }*/
    var dat = JSON.stringify({
      id: "okTransaction",
      transactionToken: this.$store.state.route.query.transactionToken,
      success: true
    });
    console.log(dat);

    window.top.postMessage(dat, "*");
  }
};
</script>


<style scoped>
.cmsg {
  margin-top: 40px;
}
</style>